<template>
	<button
		:class="`element element--button element--button--${name}`"
		:config-active="configactive"
		:aria-pressed="ariaPressed"
		:element-translation="i18n ? elementTranslation.found : elementTranslation.missing"
		@click="$emit('click', $event)"
		data-url
		@animationend="onAnimationEnd(this)"
	>
		{{ translatedContent }}
		<div class="element element--icon"></div>
	</button>
</template>

<script>
import { elementTranslation } from '../../tools/consts';
import { i18n } from '../../tools/i18n';

export default {
	props: {
		name: String,
		content: String,
		i18n: Boolean,
		configactive: String,
	},
	data: function() {
		return {
			ariaPressed: false,
		};
	},
	computed: {
		translatedContent() {
			return this.i18n ? i18n.t(this.content) : this.content;
		},
	},
	methods: {
		click() {
			this.ariaPressed = true;
			this.$emit('click');
		},
		onAnimationEnd() {
			this.$emit('onAnimationEnd');
		},
	},
	created() {
		this.elementTranslation = elementTranslation;
	},
};
</script>

<style lang="scss"></style>
